jQuery.feature_import("js-recipe-information",
  () => import("./recipe-information.js"),
  mod => mod.feature_js_recipe_information
);